/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * DasAR Web API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

/**
 * @nullable
 */
export type SuccessType = {
  success: boolean;
  message: string;
} | null;

export type ErrorsTypeItem = {
  /** @nullable */
  field: string | null;
  detail: string;
};

/**
 * @nullable
 */
export type ErrorsType = ErrorsTypeItem[] | null;

export type InvitationTypeState = typeof InvitationTypeState[keyof typeof InvitationTypeState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvitationTypeState = {
  pending: 'pending',
  viewed: 'viewed',
  accepted: 'accepted',
  revoked: 'revoked',
} as const;

/**
 * @nullable
 */
export type InvitationTypeMetadata = {
  projectUids?: string[];
} | null;

export interface InvitationType {
  /** @nullable */
  type: string | null;
  uid: string;
  email: string;
  state: InvitationTypeState;
  role: string;
  /** @nullable */
  acceptedAt: string | null;
  /** @nullable */
  resentAt: string | null;
  /** @nullable */
  expiresAt: string | null;
  createdAt: string;
  /** @nullable */
  metadata: InvitationTypeMetadata;
}

export type InvoiceTypeState = typeof InvoiceTypeState[keyof typeof InvoiceTypeState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceTypeState = {
  pending: 'pending',
  paid: 'paid',
} as const;

export type InvoiceTypeMetadataPaymentCard = {
  brand?: string;
  ending?: string;
  expMonth?: number;
  expYear?: number;
};

export type InvoiceTypeMetadataSubscription = {
  name?: string;
  start?: string;
  end?: string;
};

export type InvoiceTypeMetadata = {
  paymentCard?: InvoiceTypeMetadataPaymentCard;
  subscription?: InvoiceTypeMetadataSubscription;
};

export interface InvoiceType {
  /** @nullable */
  type: string | null;
  uid: string;
  code: string;
  state: InvoiceTypeState;
  currency: string;
  priceCents: number;
  invoiceUrl: string;
  invoicePdf: string;
  createdAt: string;
  metadata: InvoiceTypeMetadata;
}

export interface MeType {
  /** @nullable */
  type: string | null;
  uid: string;
  email: string;
  firstName: string;
  lastName: string;
  name: string;
  handle: string;
  /** @nullable */
  imageUrl: string | null;
  /** @nullable */
  lastActiveAt: string | null;
  emailVerified: boolean;
  /** @nullable */
  plan: PlanType;
  /** @nullable */
  paymentCard: PaymentCardType;
}

export type MeshTypeFileFormat = typeof MeshTypeFileFormat[keyof typeof MeshTypeFileFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MeshTypeFileFormat = {
  glb: 'glb',
  gltf: 'gltf',
  usdz: 'usdz',
} as const;

export interface MeshType {
  /** @nullable */
  type: string | null;
  uid: string;
  name: string;
  fileFormat: MeshTypeFileFormat;
  /** @nullable */
  fileUrl: string | null;
  /** @nullable */
  fileUsdzUrl: string | null;
  /** @nullable */
  imageUrl: string | null;
  byteSize?: number;
  /** @nullable */
  assigned?: boolean | null;
  projectsCount?: number;
  viewCount?: number;
  createdAt?: string;
  /** @nullable */
  owner?: UserType;
  /** @nullable */
  uploader?: UserType;
}

export interface OrganizationType {
  /** @nullable */
  type: string | null;
  uid: string;
  name: string;
  slug: string;
}

/**
 * @nullable
 */
export type PaymentCardTypeBillingAddress = {
  name: string;
  line1?: string;
  /** @nullable */
  line2?: string | null;
  postalCode?: number;
  state?: string;
  city?: string;
  country: string;
} | null;

export interface PaymentCardType {
  /** @nullable */
  type: string | null;
  uid: string;
  country: string;
  brand: string;
  ending: string;
  expMonth: number;
  expYear: number;
  /** @nullable */
  billingAddress: PaymentCardTypeBillingAddress;
  /** @nullable */
  default: boolean | null;
}

export type PlanTypeBillingInterval = typeof PlanTypeBillingInterval[keyof typeof PlanTypeBillingInterval];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlanTypeBillingInterval = {
  month: 'month',
  year: 'year',
} as const;

export type PlanTypeBilling = {
  symbol: string;
  currency: string;
  priceCents: number;
  interval: PlanTypeBillingInterval;
  intervalCount: number;
  custom: boolean;
};

export interface PlanType {
  /** @nullable */
  type: string | null;
  uid: string;
  name: string;
  /** @nullable */
  description: string | null;
  variantOf: string;
  sequence: number;
  billing: PlanTypeBilling;
  features: PlanFeaturesType;
  featuresOverride: PlanFeaturesType;
}

export interface ProjectType {
  /** @nullable */
  type: string | null;
  uid: string;
  name: string;
  slug: string;
  previewState?: ProjectStateType;
  liveState?: ProjectStateType;
  /** @nullable */
  creatorName?: string | null;
  /** @nullable */
  creatorHandle?: string | null;
  recordAnalytics?: boolean;
  membersCount?: number;
  meshesCount?: number;
  /** @nullable */
  isSaved?: boolean | null;
  /** @nullable */
  isPublished?: boolean | null;
  /** @nullable */
  organizationName?: string | null;
  updatedAt?: string;
  /** @nullable */
  isMine?: boolean | null;
  /** @nullable */
  byteSizeLimit?: number | null;
  meshes?: MeshType[];
  users?: UserType[];
}

export interface ResourceType {
  /** @nullable */
  type: string | null;
  uid: string;
  name: string;
  /** @nullable */
  fileFormat: string | null;
  /** @nullable */
  fileUrl: string | null;
  byteSize?: number;
  projectsCount?: number;
  createdAt?: string;
  /** @nullable */
  owner?: UserType;
  /** @nullable */
  uploader?: UserType;
}

export interface SessionType {
  /** @nullable */
  type: string | null;
  uid: string;
  /** @nullable */
  ip: string | null;
  /** @nullable */
  userAgent: string | null;
  /** @nullable */
  expiresAt: string | null;
  createdAt: string;
}

export interface UserType {
  /** @nullable */
  type: string | null;
  uid: string;
  email: string;
  name: string;
  handle: string;
  /** @nullable */
  imageUrl: string | null;
  /** @nullable */
  lastActiveAt: string | null;
  /** @nullable */
  collabProjectsCount?: number | null;
  /** @nullable */
  projectRole?: string | null;
}

export type PlanFeaturesTypeItemValue = number | boolean;

/**
 * @nullable
 */
export type PlanFeaturesTypeItem = {
  id: string;
  name: string;
  desc: string;
  valueReadable?: string;
  value: PlanFeaturesTypeItemValue;
} | null;

export type PlanFeaturesType = PlanFeaturesTypeItem[];

/**
 * @nullable
 */
export type ProjectStateType = {
  version: number;
  published: boolean;
  publishedAt: string;
  /** @nullable */
  publishedBy: string | null;
  token: string;
  /** @nullable */
  contentToken: string | null;
  meshesUids: string[];
} | null;

export type GetMeshesParams = {
state: GetMeshesState;
slug?: string;
token?: string;
};

export type GetMeshesState = typeof GetMeshesState[keyof typeof GetMeshesState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMeshesState = {
  preview: 'preview',
  live: 'live',
} as const;

export type GetMeshes200 = {
  data: MeshType[];
  errors: ErrorsType;
};

/**
 * @nullable
 */
export type GetMeshes404Data = unknown | null;

export type GetMeshes404 = {
  /** @nullable */
  data: GetMeshes404Data;
  errors: ErrorsType;
};

export type GetMeshParams = {
state: GetMeshState;
slug?: string;
token?: string;
};

export type GetMeshState = typeof GetMeshState[keyof typeof GetMeshState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMeshState = {
  preview: 'preview',
  live: 'live',
} as const;

export type GetMesh200 = {
  data: MeshType;
  errors: ErrorsType;
};

/**
 * @nullable
 */
export type GetMesh404Data = unknown | null;

export type GetMesh404 = {
  /** @nullable */
  data: GetMesh404Data;
  errors: ErrorsType;
};

export type GetProjectParams = {
handle: string;
};

export type GetProject200 = {
  data: ProjectType;
  errors: ErrorsType;
};

export type PreviewProjectParams = {
handle: string;
};

export type PreviewProject200 = {
  data: ProjectType;
  errors: ErrorsType;
};

/**
 * @summary Get meshes
 */
export const getMeshes = (
    params: GetMeshesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetMeshes200>> => {
    
    
    return axios.default.get(
      `/api/v1/web/meshes`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetMeshesQueryKey = (params: GetMeshesParams,) => {
    return [`/api/v1/web/meshes`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMeshesQueryOptions = <TData = Awaited<ReturnType<typeof getMeshes>>, TError = AxiosError<GetMeshes404>>(params: GetMeshesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeshes>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeshesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeshes>>> = ({ signal }) => getMeshes(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMeshes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeshesQueryResult = NonNullable<Awaited<ReturnType<typeof getMeshes>>>
export type GetMeshesQueryError = AxiosError<GetMeshes404>


export function useGetMeshes<TData = Awaited<ReturnType<typeof getMeshes>>, TError = AxiosError<GetMeshes404>>(
 params: GetMeshesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeshes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeshes>>,
          TError,
          Awaited<ReturnType<typeof getMeshes>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeshes<TData = Awaited<ReturnType<typeof getMeshes>>, TError = AxiosError<GetMeshes404>>(
 params: GetMeshesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeshes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeshes>>,
          TError,
          Awaited<ReturnType<typeof getMeshes>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeshes<TData = Awaited<ReturnType<typeof getMeshes>>, TError = AxiosError<GetMeshes404>>(
 params: GetMeshesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeshes>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get meshes
 */

export function useGetMeshes<TData = Awaited<ReturnType<typeof getMeshes>>, TError = AxiosError<GetMeshes404>>(
 params: GetMeshesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeshes>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeshesQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get mesh
 */
export const getMesh = (
    uid: string,
    params: GetMeshParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetMesh200>> => {
    
    
    return axios.default.get(
      `/api/v1/web/meshes/${uid}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetMeshQueryKey = (uid: string,
    params: GetMeshParams,) => {
    return [`/api/v1/web/meshes/${uid}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMeshQueryOptions = <TData = Awaited<ReturnType<typeof getMesh>>, TError = AxiosError<GetMesh404>>(uid: string,
    params: GetMeshParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMesh>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeshQueryKey(uid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMesh>>> = ({ signal }) => getMesh(uid,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(uid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMesh>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeshQueryResult = NonNullable<Awaited<ReturnType<typeof getMesh>>>
export type GetMeshQueryError = AxiosError<GetMesh404>


export function useGetMesh<TData = Awaited<ReturnType<typeof getMesh>>, TError = AxiosError<GetMesh404>>(
 uid: string,
    params: GetMeshParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMesh>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMesh>>,
          TError,
          Awaited<ReturnType<typeof getMesh>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMesh<TData = Awaited<ReturnType<typeof getMesh>>, TError = AxiosError<GetMesh404>>(
 uid: string,
    params: GetMeshParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMesh>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMesh>>,
          TError,
          Awaited<ReturnType<typeof getMesh>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMesh<TData = Awaited<ReturnType<typeof getMesh>>, TError = AxiosError<GetMesh404>>(
 uid: string,
    params: GetMeshParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMesh>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get mesh
 */

export function useGetMesh<TData = Awaited<ReturnType<typeof getMesh>>, TError = AxiosError<GetMesh404>>(
 uid: string,
    params: GetMeshParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMesh>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeshQueryOptions(uid,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get project
 */
export const getProject = (
    slug: string,
    params: GetProjectParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetProject200>> => {
    
    
    return axios.default.get(
      `/api/v1/web/projects/${slug}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetProjectQueryKey = (slug: string,
    params: GetProjectParams,) => {
    return [`/api/v1/web/projects/${slug}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetProjectQueryOptions = <TData = Awaited<ReturnType<typeof getProject>>, TError = AxiosError<unknown>>(slug: string,
    params: GetProjectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectQueryKey(slug,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProject>>> = ({ signal }) => getProject(slug,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(slug), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectQueryResult = NonNullable<Awaited<ReturnType<typeof getProject>>>
export type GetProjectQueryError = AxiosError<unknown>


export function useGetProject<TData = Awaited<ReturnType<typeof getProject>>, TError = AxiosError<unknown>>(
 slug: string,
    params: GetProjectParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProject>>,
          TError,
          Awaited<ReturnType<typeof getProject>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProject<TData = Awaited<ReturnType<typeof getProject>>, TError = AxiosError<unknown>>(
 slug: string,
    params: GetProjectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProject>>,
          TError,
          Awaited<ReturnType<typeof getProject>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProject<TData = Awaited<ReturnType<typeof getProject>>, TError = AxiosError<unknown>>(
 slug: string,
    params: GetProjectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project
 */

export function useGetProject<TData = Awaited<ReturnType<typeof getProject>>, TError = AxiosError<unknown>>(
 slug: string,
    params: GetProjectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectQueryOptions(slug,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Preview project
 */
export const previewProject = (
    projectToken: string,
    params: PreviewProjectParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PreviewProject200>> => {
    
    
    return axios.default.get(
      `/api/v1/web/projects/${projectToken}/preview`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getPreviewProjectQueryKey = (projectToken: string,
    params: PreviewProjectParams,) => {
    return [`/api/v1/web/projects/${projectToken}/preview`, ...(params ? [params]: [])] as const;
    }

    
export const getPreviewProjectQueryOptions = <TData = Awaited<ReturnType<typeof previewProject>>, TError = AxiosError<unknown>>(projectToken: string,
    params: PreviewProjectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewProject>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewProjectQueryKey(projectToken,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewProject>>> = ({ signal }) => previewProject(projectToken,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(projectToken), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewProject>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PreviewProjectQueryResult = NonNullable<Awaited<ReturnType<typeof previewProject>>>
export type PreviewProjectQueryError = AxiosError<unknown>


export function usePreviewProject<TData = Awaited<ReturnType<typeof previewProject>>, TError = AxiosError<unknown>>(
 projectToken: string,
    params: PreviewProjectParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewProject>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewProject>>,
          TError,
          Awaited<ReturnType<typeof previewProject>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewProject<TData = Awaited<ReturnType<typeof previewProject>>, TError = AxiosError<unknown>>(
 projectToken: string,
    params: PreviewProjectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewProject>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewProject>>,
          TError,
          Awaited<ReturnType<typeof previewProject>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewProject<TData = Awaited<ReturnType<typeof previewProject>>, TError = AxiosError<unknown>>(
 projectToken: string,
    params: PreviewProjectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewProject>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preview project
 */

export function usePreviewProject<TData = Awaited<ReturnType<typeof previewProject>>, TError = AxiosError<unknown>>(
 projectToken: string,
    params: PreviewProjectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewProject>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPreviewProjectQueryOptions(projectToken,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}
